import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";

const Login = () => {
  const navigate = useNavigate();

  return (
    <AuthenticationWrawper>
      <>
        <div className="text-section-of-create-new-acc"
        >
          If you are a customer and would like to register with this email,
          please talk to your Muztrans representative, or write to us at{" "}
          <b> info@muztrans.com</b>
        </div>
        <div
          className="d-flex flex-row justify-content-between "
          style={{ marginTop: 70, height: 70, paddingTop: 7, marginBottom: -18 }}
        >
          <div
            className="d-flex flex-column"
            style={{ position: "absolute", left: -8 }}
            onClick={() => navigate("/login")}
          >
            <button
              className="d-flex justify-content-center align-items-center next-button-style create-back-button-style"
              type="submit"
            >
              <i className="bi bi-arrow-left" style={{ fontSize: 16, marginRight: 5 }}></i>
              BACK
            </button>
            <div className="d-flex justify-content-start">
              <i className="bi bi-caret-right-fill fold-back-button-styling"></i>
            </div>

          </div>

        </div>
      </>
    </AuthenticationWrawper>
  );
};

export default Login;
